import { render, staticRenderFns } from "./DeptManager.vue?vue&type=template&id=5c77d7a8&scoped=true&"
import script from "./DeptManager.vue?vue&type=script&lang=js&"
export * from "./DeptManager.vue?vue&type=script&lang=js&"
import style0 from "./DeptManager.vue?vue&type=style&index=0&id=5c77d7a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c77d7a8",
  null
  
)

export default component.exports